<template>
  <div class="template-wrap week-event-template" v-bind:class="computedClass">
    <div class="subject">
      <div class="group-1">
        <span>{{ data.subject }}</span>
      </div>
      <span>
        {{ data.FriendlyStatus }}
      </span>
    </div>
    <div class="description">
      <span>{{ data.ProductCode }}</span
      ><br />
      <span>{{ data.ProductDescription1 }} </span>
    </div>
    <div class="data">
      <div class="planned">
        <span>Planned </span>&nbsp;
        <span>
          {{ getFormattedQty(data.RequiredQty) }}
          {{ data.StockUM }}
        </span>
      </div>
      <div class="actual">
        <div class="actual-items">
          <span>Actual</span>&nbsp;
          <span>
            {{ getFormattedQty(data.RequiredQty) }}
            {{ data.StockUM }}
          </span>
        </div>
        <GcCommentIcon v-if="data.HasNote === 'Y'" class="calendar-comment" />
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from "devextreme/localization";
import GcCommentIcon from "../gc-comment-icon.vue";

export default {
  components: { GcCommentIcon },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
  },
  computed: {
    computedClass() {
      const status = this.data.FriendlyStatus
        ? this.data.FriendlyStatus.toFriendlyStatus()
        : false;
      return {
        active: status === "Active",
        inproduction: status === "In Production",
        completed: status === "Completed",
        cancelled: status === "Cancelled",
        draft: status === "Draft",
      };
    },
  },
};
</script>

<style lang="scss">
.e-appointment-details {
  .active {
    background: #62d26f;
  }

  .inproduction {
    background-color: #ffa500;
  }

  .completed {
    background-color: #4186e0;
  }

  .cancelled {
    background-color: #e8384f;
  }

  .week-event-template {
    padding: 5px 5px;
    .subject {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }

    .subject > span {
      font-size: 10px;
    }

    .description {
      font-size: 12px;

      span:last-child {
        text-wrap: wrap;
      }
    }

    .data {
      font-size: 10px;
      display: flex;
      justify-content: space-between;
      // .planned {
      //   padding-right: 25px;
      // }
      .actual {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
      }
    }

    @media screen and (max-width: 1750px) {
      .data {
        flex-direction: column;

        .actual {
          flex-direction: unset;
        }
      }
    }
  }
}
</style>
